import React from "react";
import { motion } from "framer-motion";
import { Chip } from "@mui/material";
import "./MyTechProfileExperienceComponent.css";
import AnimatedGradientText from "./AnimatedGradient";
import { useSelector } from "react-redux";

const MyTechProfileExperienceComponent = ({ experiencesRef }) => {
  const { profile } = useSelector((state) => state.editMyTechProfileStore);
  const cardVariants = {
    hidden: (rotation) => ({
      y: 50,
      scale: 0.9,
      rotate: rotation,
    }),
    visible: (rotation) => ({
      y: 0,
      scale: 1,
      rotate: rotation,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    }),
    hover: {
      y: -5,
      rotate: 0,
      scale: 1.02,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20,
      },
    },
  };

  // Floating orb animation variants
  const orbVariants = {
    animate: {
      x: [-200, 0, 200, 0, -200, 200, -200, 0], // moves left ↔ right
      y: [-200, 0, 200, -200, 200, 200, -200, 0], // moves top ↔ bottom
      transition: {
        duration: 80,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
  };

  return (
    <div style={{ marginTop: "130px" }}>
      <div className="mytechprofileExperience-header">
        <h3 className="mytechprofileproject-subtitle">Know me Better</h3>
        <h1 className="mytechprofileproject-title">
          My <AnimatedGradientText text="Experiences" />
        </h1>
      </div>
      <div ref={experiencesRef} />
      <div className="mytechprofile-experience-wrapper">
        {profile?.experiences?.map((exp) => (
          <motion.div
            key={exp?.experience_id}
            className="mytechprofile-experience-card"
            initial="hidden"
            whileInView="visible"
            whileHover="hover"
            viewport={{ once: true, amount: 0.3 }}
            variants={cardVariants}
            style={{ transformOrigin: "top center" }}
          >
            {/* Floating Purple Orb */}
            <motion.div
              className="mytechprofile-floating-orb"
              variants={orbVariants}
              animate="animate"
            />

            {/* Folder Tab */}
            <div className="mytechprofile-folder-tab"></div>

            {/* Card Content Wrapper */}
            <div className="mytechprofile-card-content">
              {/* Company Header */}
              <div className="mytechprofile-company-header">
                <img
                  src={exp?.logo}
                  alt={exp?.company}
                  className="mytechprofile-company-logo"
                />
                <h3 className="mytechprofile-company-name">{exp?.company}</h3>
              </div>

              {/* Job Title and Date */}
              <div className="mytechprofile-job-info">
                <h4 className="mytechprofile-job-title">{exp?.title}</h4>
                <p className="mytechprofile-job-date">
                  {exp?.startDate} - {exp?.endDate}
                </p>
              </div>

              {/* Job Details */}
              <div className="mytechprofile-job-details">
                <p>{exp?.details}</p>
              </div>

              {/* Tech Stack */}
              {exp?.techStack && exp?.techStack?.length > 0 && (
                <div className="mytechprofile-tech-stack">
                  {exp?.techStack?.map((tech, idx) => (
                    <Chip
                      key={idx}
                      label={tech?.name}
                      avatar={
                        <img
                          src={tech?.icon}
                          alt={tech?.label}
                          style={{
                            width: "20px",
                            height: "20px",
                            objectFit: "contain",
                          }}
                        />
                      }
                      className="mytechprofile-tech-chip"
                      variant="outlined"
                    />
                  ))}
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default MyTechProfileExperienceComponent;
